import { useEffect, useState } from 'react'
import { Upload } from 'lucide-react'

import PageLayout from '../components/layout/PageLayout'
import JobDataTable from '@/components/JobDataTable'
import { Button } from '../components/ui/button'
import Paginator from '@/components/Paginator'
import JobCreateModal from '@/components/JobCreateModal'
import { useAppStore } from '../store'
import { useTranslation } from '@/i18n'

const REFRESH_INTERVAL = 5000

const PageActions = ({ onCreateClick, label }: { onCreateClick: () => void; label: string }) => (
  <Button size="sm" onClick={onCreateClick}>
    <Upload className="w-5 h-5 mr-2" />
    {label}
  </Button>
)

const Jobs = () => {
  const { currentPage, totalPages, pageSize, fetchJobs, setPage, setPageSize, totalJobs } =
    useAppStore()
  const { t } = useTranslation()

  // State to open/close the modal
  const [isModalOpen, setIsModalOpen] = useState(false)

  // Calls fetchJobs when the component mounts and every 5 seconds
  useEffect(() => {
    fetchJobs()
    const jobInterval = setInterval(() => {
      fetchJobs()
    }, REFRESH_INTERVAL)
    return () => {
      clearInterval(jobInterval)
    }
  }, [fetchJobs])

  return (
    <PageLayout
      title={t('jobs:page_title')}
      pageTools={() => (
        <PageActions onCreateClick={() => setIsModalOpen(true)} label={t('jobs:create_button')} />
      )}
    >
      {/* Jobs Table */}
      <div className="border rounded-lg">
        <JobDataTable />
      </div>

      {/* Paginator */}
      <Paginator
        currentPage={currentPage}
        totalPages={totalPages}
        pageSize={pageSize}
        setPage={setPage}
        setPageSize={setPageSize}
        totalItems={totalJobs}
      />

      {/* Job Creation Modal */}
      <JobCreateModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />
    </PageLayout>
  )
}

export default Jobs
